function FormValidator() {}

FormValidator.cleanPhone = function(text) {
    text = text.split('.').join('');
    text = text.split(',').join('');
    text = text.split('-').join('');
    text = text.split(' ').join('');
    text = text.split('+').join('');

    return text;
};

FormValidator.isEmpty = function(text) {
    return text.length === 0;
};

FormValidator.hasMinLength = function(text, minChars) {
    return text.length >= minChars;
};

FormValidator.isNumber = function(text) {
    return !this.isEmpty(text) && !isNaN(this.cleanPhone(text));
};

FormValidator.isValidEmail = function (address) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(address);
};

FormValidator.isValidURL = function(url) {
    var re = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

    return re.test(url);
};

